import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Collapse, Table, Typography, Spin, message } from "antd";
import { find  } from "lodash";
import { handlegetLicenseUtilization } from "store/licences/thunks";
import { useBookOrder } from "store/books/selectors";

const { Title } = Typography;
const { Panel } = Collapse;

type SessionGroup = {
  title: string;
  groups: Record<string, number>;
};

type DistrictPreviewData = {
  no_of_school: number;
  no_of_students: number;
  no_of_classes: number;
  total_utilization: number;
  session: SessionGroup[];
};

type Props = {
  open: boolean;
  onClose: () => void;
  orgId: string | null;
  type: string | null;
};

const DistrictPreviewModal: React.FC<Props> = ({ open, onClose, orgId , type }) => {
  const [data, setData] = useState<DistrictPreviewData | null>(null);
  const [loading, setLoading] = useState(false);
  const bookOrder = useBookOrder()
  const fetchData = async () => {
    try {
      setLoading(true);
      setData(null);
      const data = await handlegetLicenseUtilization(orgId,type?type:"school")
      if(data&&data.success){
        setData(data.data)
      }else{
        message.error(`Something went wrong ${data?.message}`)
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (open && orgId) {
     fetchData()
    }
  }, [open, orgId]);
  const getTitle=(key) =>{
    const group = find(bookOrder,["key",key])
    if(group) return group.title;
    return `${key}`.replaceAll("-"," ")
  }

  return (
    <Modal
      title={<Title level={4}>District License Usage Overview</Title>}
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      destroyOnHidden
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <Spin size="large" />
        </div>
      ) : data ? (
        <>
          <Descriptions
            bordered
            column={2}
            size="small"
            layout="horizontal"
            style={{ marginBottom: 16 }}
          >
            <Descriptions.Item label="Total Schools">
              {data.no_of_school}
            </Descriptions.Item>
            <Descriptions.Item label="Total Students">
              {data.no_of_students}
            </Descriptions.Item>
            <Descriptions.Item label="Total Classes">
              {data.no_of_classes}
            </Descriptions.Item>
            <Descriptions.Item label="Total Utilization">
              {data.total_utilization}
            </Descriptions.Item>
          </Descriptions>

            <Collapse accordion>
              {Array.isArray(data.session)&&data.session.map((session) => (
                <Panel header={<strong>{session.title}</strong>} key={session.title}>
                  <Table
                    size="small"
                    rowKey="key"
                    pagination={false}
                    dataSource={Object.entries(session.groups)
                      .map(([group, count]) => ({
                        key: group,
                        title: getTitle(group),
                        count,
                      }))
                      .sort((a, b) => b.count - a.count) // Sort descending by count
                    }
                    columns={[
                      {
                        title: "Book group",
                        dataIndex: "title",
                        key: "title",
                      },
                      {
                        title: "Total Appearances",
                        dataIndex: "count",
                        key: "count",
                      },
                    ]}
                  />
                </Panel>
              ))}
            </Collapse>
        </>
      ) : (
        <p>No data available.</p>
      )}
    </Modal>
  );
};

export default DistrictPreviewModal;